import { useEffect } from 'react';
import { useQuery } from 'react-query';
import { useAppDispatch, useAppSelector } from '@app/store/hooks';
import { getMyPermissionsService } from '@shared/services/get-my-permissions.service';
import { setPermissions } from '@shared/slices/permissions.slice';

export function usePermissions() {
  const dispatch = useAppDispatch();
  const { userToken } = useAppSelector(state => state.auth);
  const { permissions } = useAppSelector(state => state.permissions);

  const { data } = useQuery(['my/permissions'], getMyPermissionsService, {
    refetchInterval: 60000,
    enabled: !!userToken,
  });

  useEffect(() => {
    if (data) dispatch(setPermissions(data));
  }, [data]);

  return {
    permissions,
  };
}
